import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import _ from 'lodash';

import { EXPORT_ITEMS_FORM_NAME } from 'Common/FormEnum';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import { DroppableAreaEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';
import {
  validateExportForm,
  reorder,
  move,
} from './../../../helper/importExport';
import { getColumns } from './../../../state/importExport/actions';
import ExportItemsComponent from './../components/ExportItems';

class ExportItems extends Component {
  currentDate = moment();

  onItemClick = (item, selectedArea) => {
    const { setStateChipsData, allChipsData, selectedChipsData } = this.props;
    let cloneSelectedChipsData = _.cloneDeep(selectedChipsData);
    let cloneAllChipsData = _.cloneDeep(allChipsData);
    if (selectedArea) {
      const index = _.findIndex(cloneSelectedChipsData, chipItem => {
        return chipItem.ColPreferenceId === item.ColPreferenceId;
      });
      if (index !== -1) {
        cloneAllChipsData = [
          ...cloneAllChipsData,
          ..._.remove(cloneSelectedChipsData, o => item.ColName === o.ColName),
        ];
      }
    } else {
      const index = _.findIndex(allChipsData, chipItem => {
        return chipItem.ColPreferenceId === item.ColPreferenceId;
      });
      if (index !== -1) {
        cloneSelectedChipsData = [
          ...cloneSelectedChipsData,
          ..._.remove(cloneAllChipsData, o => item.ColName === o.ColName),
        ];
      }
    }
    setStateChipsData(cloneAllChipsData, cloneSelectedChipsData);
  };
  onDragEnd = result => {
    const { setStateChipsData, selectedChipsData, allChipsData } = this.props;
    const { source, destination } = result;
    if (
      !destination ||
      (destination && destination.droppableId === DroppableAreaEnum.Selected)
    ) {
      return;
    }
    if (
      source.droppableId === destination.droppableId &&
      destination.droppableId !== DroppableAreaEnum.Selected
    ) {
      const items = reorder(
        selectedChipsData,
        result.source.index,
        result.destination.index
      );
      setStateChipsData(allChipsData, items);
    } else {
      const { setStateChipsData, allChipsData, selectedChipsData } = this.props;
      const result = move(allChipsData, selectedChipsData, source, destination);
      setStateChipsData(
        result[DroppableAreaEnum.Selected],
        result[DroppableAreaEnum.NonSelected]
      );
    }
  };
  addAll = e => {
    e.preventDefault();
    const { setStateChipsData, columns } = this.props;
    setStateChipsData([], columns);
  };
  removeAll = e => {
    e.preventDefault();
    const { setStateChipsData, columns } = this.props;
    setStateChipsData(columns, []);
  };
  handleToBeExportedFields = (e, selectedId) => {
    const { setStateChipsData, columns } = this.props;
    let cloneAllChipsData = _.cloneDeep(columns);
    const { existingExportConfig, change } = this.props;
    const selectedObject = _.find(existingExportConfig, item => {
      return item.Id === selectedId;
    });
    if (selectedObject) {
      let sequenceItems = [];
      let fieldNameArray = selectedObject.SelectedFields.split(',');
      const removedItems = _.remove(
        cloneAllChipsData,
        item => fieldNameArray.indexOf(item.ColName) !== -1
      );
      _.forEach(fieldNameArray, colName => {
        const item = _.find(removedItems, ['ColName', colName]);
        if (item) {
          sequenceItems.push(item);
        }
      });
      setStateChipsData(cloneAllChipsData, sequenceItems);
      change(
        [ImportExportItemsEnum.IncludeHeaders],
        selectedObject[ImportExportItemsEnum.IncludeHeaders]
      );
      change(
        [ImportExportItemsEnum.Delimiter],
        selectedObject[ImportExportItemsEnum.Delimiter]
      );
      change(
        [ImportExportItemsEnum.SelectedFields],
        selectedObject[ImportExportItemsEnum.SelectedFields]
      );
      change(
        [ImportExportItemsEnum.IncludeWOCurrentBidPrice],
        selectedObject[ImportExportItemsEnum.IncludeWOCurrentBidPrice]
      );
    }
  };

  handleExportTypeChange = () => {
    const { change, setStateChipsData, columns } = this.props;
    //resetForm prop function is not working with updating reducer.
    change([ImportExportItemsEnum.IncludeWOCurrentBidPrice], true);
    change([ImportExportItemsEnum.Delimiter], ',');
    change([ImportExportItemsEnum.IncludeHeaders], true);
    setStateChipsData(columns, []);
    change([ImportExportItemsEnum.Name], '');
    change(ImportExportItemsEnum.LoadPrevious, '');
  };

  render() {
    const {
      exportType,
      loadPreviousOptionsDropDown,
      handleSubmit,
      allChipsData,
      selectedChipsData,
    } = this.props;

    return (
      <ExportItemsComponent
        exportType={exportType}
        loadPreviousOptionsDropDown={loadPreviousOptionsDropDown}
        handleSubmit={handleSubmit}
        allChipsData={allChipsData}
        selectedChipsData={selectedChipsData}
        onItemClick={this.onItemClick}
        onDragEnd={this.onDragEnd}
        addAll={this.addAll}
        removeAll={this.removeAll}
        handleToBeExportedFields={this.handleToBeExportedFields}
        handleExportTypeChange={this.handleExportTypeChange}
      />
    );
  }
}

ExportItems = reduxForm({
  destroyOnUnmount: false,
  form: EXPORT_ITEMS_FORM_NAME,
  validate: validateExportForm,
})(ExportItems);

const selector = formValueSelector(EXPORT_ITEMS_FORM_NAME);
const mapStateToProps = state => {
  const { importExport } = state.UtilitiesState;
  const { loadPreviousOptionsDropDown, existingExportConfig } = importExport;
  return {
    exportType: selector(state, ImportExportItemsEnum.Type),
    delimiter: selector(state, ImportExportItemsEnum.Delimiter),
    loadPrevious: selector(state, ImportExportItemsEnum.LoadPrevious),
    loadPreviousOptionsDropDown,
    existingExportConfig,
  };
};
const mapDispatchToProps = {
  getColumns,
};
export const ExportItemsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportItems);



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/exportInventory/containers/ExportItems.js